const WORK_TRANSACTION_LIST = "admin/work-transactions/list?";
const WORK_TRANSACTION_DETAILS = "/admin/work-transactions";

const apiUrl = {
  WORK_TRANSACTION_LIST,
  WORK_TRANSACTION_DETAILS,
};

export default apiUrl;
